enum ActionTypes {
	requestItems = 'GroupProduct.requestItems',
	receiveItems = 'GroupProduct.receiveItems',
	requestItem = 'GroupProduct.requestItem',
	receiveItem = 'GroupProduct.receiveItem',
	requestAddToGroup = 'GroupProduct.requestAddToGroup',
	receiveAddToGroup = 'GroupProduct.receiveAddToGroup',
	requestAddToGroupBySearch = 'GroupProduct.requestAddToGroupBySearch',
	receiveAddToGroupBySearch = 'GroupProduct.receiveAddToGroupBySearch',
	requestRemoveFromGroup = 'GroupProduct.requestRemoveFromGroup',
	receiveRemoveFromGroup = 'GroupProduct.receiveRemoveFromGroup',
	markPackageSizeForSingleUnitChanged = 'GroupProduct.markPackageSizeForSingleUnitChanged',
	requestUpdatePackageSizeForSingleUnit = 'GroupProduct.requestUpdatePackageSizeForSingleUnit',
	receiveUpdatePackageSizeForSingleUnit = 'GroupProduct.receiveUpdatePackageSizeForSingleUnit',
	prune = 'GroupProduct.prune',
	setupItemsPerPage = 'GroupProduct.setupItemsPerPage',
}

export default ActionTypes;
